import {
  alpha,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useTheme,
} from "@mui/material";
import { useState } from "react";

export default function CustomTable({
  columns,
  data,
  onRowClick,
  getRowKey,
  cursor = false,
  pagination = true,
}) {
  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const paginated =
    rowsPerPage > 0
      ? data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : data;

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const theme = useTheme();
  const defaultRowStyle = (index) => {
    const evenBg = theme.palette.background.paper; // světlé / tmavé pozadí
    const oddBg =
      theme.palette.mode === "light"
        ? theme.palette.grey[100]
        : alpha("#ffffff", 0.04); // jemný pruh v dark-mode

    const hoverBg =
      theme.palette.mode === "light"
        ? alpha(theme.palette.primary.main, 0.1)
        : alpha(theme.palette.primary.light, 0.15);

    return {
      "& > *": {
        backgroundColor: index % 2 === 0 ? evenBg : oddBg,
      },

      ...(cursor
        ? { "&:hover > *": { backgroundColor: hoverBg } }
        : { "&:hover > *": { backgroundColor: "inherit" } }),
    };
  };

  const StyledTableCell = styled(TableCell)(() => ({
    textAlign: "center",
    cursor: cursor ? "pointer" : "",
  }));

  const rows = pagination ? paginated : data;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.id} align={col.align || "center"}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow
              key={getRowKey ? getRowKey(row) : index}
              hover
              onClick={onRowClick ? () => onRowClick(row) : undefined}
              sx={defaultRowStyle(index)}
            >
              {columns.map((col) => (
                <StyledTableCell key={col.id} align={col.align || "center"}>
                  {col.renderCell
                    ? col.renderCell(row[col.id], row)
                    : row[col.id] || "-"}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {pagination && (
        <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, { value: -1, label: "Vše" }]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Řádků na stránku:"
        />
      )}
    </TableContainer>
  );
}
